import { render } from "./InformasiPendaftaran.vue?vue&type=template&id=67c3d37e"
import script from "./InformasiPendaftaran.vue?vue&type=script&lang=js"
export * from "./InformasiPendaftaran.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__